import Vue from 'vue';
import { TimelineSurveyResponses } from './models/TimelineSurveyResponses';
import { UserQuestions  } from './models/UserInfo';

export default class UserInfoController
{
    static async SetUserQuestions(questions : UserQuestions)
    {
        const http = Vue.axios;
        await http.post('userinfo/questions', questions);
    }

    static async GetUserQuestions()
    {
        const http = Vue.axios;
        const data = await http.get<UserQuestions>("userinfo/questions");
        return data.data;
    }

    static async SetUserTimelineSurveyResponses(responses: TimelineSurveyResponses)
    {
        const http = Vue.axios;
        await http.post('userinfo/timelinesurvey', responses);
    }

    static async GetUserTimelineSurveyResponses()
    {
        const http = Vue.axios;
        const data = await http.get<TimelineSurveyResponses>("userinfo/timelinesurvey");
        return data.data;
    }
}